
export function getDomain(s?: string) {
  const ym = [
    '.com.cn', '.net.cn', '.org.cn', '.gov.cn',
    '.com', '.cn', '.ltd', '.net', '.tech', '.shop',
    '.vip', '.xyz', '.中国', '.wang', '.cloud', '.online', '.网址',
    '.我爱你', '.在线', '.餐厅', '.icu', '.site', '.love', '.art',
    '.xin', '.store', '.fun', '.cc', '.website', '.press', '.space',
    '.beer', '.luxe', '.video', '.ren', '.group', '.fit', '.yoga',
    // '.com.cn', '.net.cn', '.org.cn', '.pro', '.ink', '.biz', '.info',
    '.pro', '.ink', '.biz', '.info',
    '.design', '.link', '.work', '.mobi', '.kim', '.pub', '.club',
    // '.tv', '.asia', '.red', '.live', '.wiki', '.gov.cn', '.life',
    '.tv', '.asia', '.red', '.live', '.wiki', '.life',
    '.world', '.run', '.show', '.city', '.gold', '.today', '.plus',
    '.cool', '.company', '.chat', '.zone', '.fans', '.law', '.host',
    '.商标', '.网店', '.中文网', '.公司', '.网络', '.集团', '.商城',
    '.招聘', '.佛山', '.广东', '.企业', '.商店', '.游戏', '.center',
    '.email', '.fund', '.social', '.team', '.娱乐', '.guru', '.co'
  ];
  const zm = [];
  ym.forEach(d => {
    zm.push(d.replace(/\./g, '\\.'))
  });
  const r = new RegExp('[^.]+(' + zm.join('|') + ')');
  const u = s || window.location.hostname;
  const rm = u.match(r);
  return rm ? rm[0] : '';
}

export function replaceDomain(s: string): string {
  let a: string = s || '';
  const h: string = window.location.href;
  const reg: RegExp = /(\/\/)([^/]+)(\/)?/;
  let am: string | string[] | null = a.match(reg);
  am = am ? am[2] : null;
  let hm: string | string[] | null = h.match(reg);
  hm = hm ? hm[2] : null;
  if (am !== hm) {
    if (s) {
      a = s.replace(reg, function($1, $2, $3, $4) {
        $3 = hm;
        return $2 + $3 + ($4 || '');
      });
    }
  }

  return a;
}